import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { CompetitionRequestApi, CompetitionRequestDto, EPlatform, ERequestState, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalCompetitionRequestForm } from "./DrupalCompetitionRequestForm";

export interface IDrupalCompetitionRequestPageProps {}

export const DrupalCompetitionRequestPage: React.FunctionComponent<IDrupalCompetitionRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const competitionRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(CompetitionRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<CompetitionRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = competitionRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new CompetitionRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: CompetitionRequestDto) => api.save(CompetitionRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.competitionRequest}/${d.competitionRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, competitionRequestId]
    ),
    [competitionRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.CompetitionRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalCompetitionRequestForm
                  competitionRequestId={competitionRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
